import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import { SERVICES } from "@/data/site";

function IconBlock({ name, className = "" }) {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} strokeWidth={1.5} />;
}

export default function Services() {
  return (
    <>
      <section className="pt-32 pb-12 md:pt-40 md:pb-16 relative">
        <div className="absolute inset-0 grid-bg radial-mask opacity-40" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="eyebrow mb-4">Capabilities</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-slate-900 max-w-4xl">
            Software, websites, lead-gen, and consulting — built to scale.
          </h1>
          <p className="mt-6 text-base md:text-lg text-slate-600 max-w-2xl leading-relaxed">
            Six core service lines designed to turn digital ideas into operational platforms,
            measurable revenue, and long-term digital assets.
          </p>
        </div>
      </section>

      <section className="pb-32" data-testid="services-page">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-6">
          {SERVICES.map((s, i) => (
            <div
              key={s.id}
              id={s.id}
              data-testid={`service-detail-${s.id}`}
              className="tracing-card p-8 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8"
            >
              <div className="lg:col-span-2">
                <div className="flex h-14 w-14 items-center justify-center border border-[#0066FF]/30 text-[#0066FF]">
                  <IconBlock name={s.icon} className="h-6 w-6" />
                </div>
                <div className="mt-4 font-mono text-xs text-slate-400">
                  / {String(i + 1).padStart(2, "0")}
                </div>
              </div>
              <div className="lg:col-span-7">
                <h2 className="font-display text-2xl md:text-3xl font-semibold text-slate-900">
                  {s.title}
                </h2>
                <p className="mt-4 text-base text-slate-600 leading-relaxed">{s.desc}</p>
              </div>
              <div className="lg:col-span-3 flex lg:justify-end lg:items-end">
                <Link
                  to={`/contact?type=${encodeURIComponent(s.title)}`}
                  className="btn-secondary"
                  data-testid={`service-cta-${s.id}`}
                >
                  Start a Project <ArrowRight size={14} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 border-t border-slate-100">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <SectionHeader
            align="center"
            eyebrow="Engage"
            title="Tell us what you need to build."
            description="Whether you have a finished spec or a napkin sketch, our team can architect the path from concept to launch."
          />
          <Link
            to="/contact"
            className="mt-8 btn-primary inline-flex"
            data-testid="services-bottom-cta"
          >
            Start a Conversation <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </>
  );
}
